import eventSessionsApi, { EventConsistTypes } from "@api/event-session";
import { useQuery } from "@tanstack/react-query";

const PAGE_SIZE = 20;

export const useEventSessionById = (eventSessionId: number | undefined) => {
    return useQuery({
        queryKey: ['eventSession', eventSessionId],
        queryFn: async () => await eventSessionsApi.getEventSessionById(eventSessionId!),
        enabled: !!eventSessionId,
    });
};

export const useEventSessions = (
    eventSessionId: number,
    ticketUuid?: string | null,
    options?: { enabled?: boolean }
) => {
    return useQuery({
        queryKey: ['eventSessions', eventSessionId, ticketUuid],
        queryFn: async () => await eventSessionsApi.getEventSessions(eventSessionId, ticketUuid),
        enabled: options?.enabled !== false && !!eventSessionId,
    });
};

export const useEventSessionsPage = (
    eventConsistTypes: EventConsistTypes | EventConsistTypes[],
    pageNumber: number,
    pageSize: number = PAGE_SIZE
) => {
    return useQuery({
        queryKey: ['eventSessionsPage', eventConsistTypes, pageNumber, pageSize],
        queryFn: async () =>
            await eventSessionsApi.getEventSessionsPage(eventConsistTypes, pageNumber, pageSize),
    });
};
